import { render, staticRenderFns } from "./EventDateIcon.vue?vue&type=template&id=435099f4&scoped=true"
import script from "./EventDateIcon.vue?vue&type=script&lang=ts"
export * from "./EventDateIcon.vue?vue&type=script&lang=ts"
import style0 from "./EventDateIcon.vue?vue&type=style&index=0&id=435099f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435099f4",
  null
  
)

export default component.exports